import React from 'react';
import { Link } from 'react-router-dom';

export const HeroSection = ({ payload }) => {
    return (
        <section className="bg-ban">
            <div className="home-hero-section">
                {payload && payload.map((item, index) => (
                    <div className="row m-0" key={index}>
                        <div className="mx-auto text-center">
                            <label className="bold fs-80 white heroname-animation">{item.companyTagline}</label>
                        </div>
                        <div className="col-12 col-sm-12 col-md-9 col-lg-9 mx-auto text-center">
                            <p className="semi-bold fs-24 white herotext-width">
                                {item.subTagline}
                            </p>
                            <div className="clear20"></div>
                            <Link to="/signup" type="button" className="request-btn fs-28 bold hero-section-button">
                                <Link className="txtblue" id="reqdemo" to="/signup">
                                    Sign Up
                                </Link>
                            </Link>
                            <div className="clear20"></div>
                            <span className="fs-16 white regular txtd">
                                <a href="#foldthird" className="white s-learn-more">
                                    Scroll to learn more
                            </a>{" "}
                            </span>
                            <div className="clear40"></div>
                        </div>
                    </div>
                ))}
            </div>
        </section>
    )
}